// 2 weeks before next year's renewal. MARKETING (PECR unsubscribe).

import type { EmailData } from "../../types";
import { anniversary, longDate } from "../../format";
import { b, body, call, esc, p } from "../../layouts/chrome";
import { callCta, plainEmailHtml } from "../../layouts/plain";
import { brand } from "../brand";

export const subject = ({ renewalDate }: EmailData) =>
  `Renewing around ${longDate(anniversary(renewalDate))}? See what ${brand.name} can do`;

export const html = (data: EmailData) =>
  plainEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    heading: "Renewing soon? Compare before you commit",
    cta: callCta(brand.callNumber),
    unsubscribeUrl: data.unsubscribeUrl,
    bodyHtml: body(
      p(
        `Your business insurance for ${b(`'${esc(data.companyName)}'`)} is likely renewing around ${b(longDate(anniversary(data.renewalDate)))} — the perfect time to check you're not overpaying.`,
      ),
      p(
        `Get a quote from ${brand.name} before you renew elsewhere, and we'll send you a ${b("£25 Amazon voucher")} when your new policy starts.`,
      ),
      p(`Call ${call(brand)} — a quote takes minutes and there's no obligation.`),
      p(
        "£25 Amazon voucher: one per business, issued after your new policy has been active for 30 days. Ask our team for full terms.",
      ),
    ),
  });
